<template>
    <ValidationProvider
        :mode="validationMode"
        :name="label || name || 'unknown'"
        :rules="rules"
        :vid="vid"
        slim
        v-slot="{ validated, valid, errors }"
    >
        <rkm-form-group
            :class="{ 'placeholder-label': label === false }"
            :invalid-feedback="errors[0]"
            :label="label ? (label + (rules && rules.required ? ' *' : '')) : null"
            :state="rules ? (validated ? valid : null) : null"
        >
            <rkm-input-group
                :append="append"
                :prepend="prepend"
            >
                <template
                    v-if="!prepend && $slots.prepend"
                    slot="prepend"
                >
                    <slot name="prepend" />
                </template>

                <b-form-file
                    :accept="accept"
                    :browse-text="browseText"
                    :disabled="disabled"
                    :drop-placeholder="dropPlaceholder"
                    :id="id"
                    :multiple="multiple"
                    :placeholder="placeholder"
                    :size="size"
                    :state="rules ? (validated ? valid : null) : null"
                    :value="value"
                    @change="$emit('change', $event)"
                    @input="$emit('input', $event)"
                />

                <template
                    v-if="!append && $slots.append"
                    slot="append"
                >
                    <slot name="append" />
                </template>
            </rkm-input-group>
        </rkm-form-group>
    </ValidationProvider>
</template>

<script>
// Components.
import {BFormFile} from 'bootstrap-vue'
import {ValidationProvider} from 'vee-validate'

export default {
    components: {BFormFile, ValidationProvider},
    computed: {
        rules() {
            return this.disabled ? null : this.validations
        },
    },
    props: {
        accept: {type: String, default: '.jpg, .png, .pdf'},
        append: {type: String},
        browseText: {type: String, default: 'Selecionar'},
        disabled: {type: Boolean},
        dropPlaceholder: {type: String, default: 'Arraste e solte aqui...'},
        label: {type: [String, Boolean], default: ''},
        name: {type: String},
        placeholder: {type: String, default: 'Nenhum arquivo selecionado'},
        prepend: {type: String, default: null},
        validationMode: {type: String, default: 'lazy'},
        validations: {type: Object, default: null},
        value: {type: [Array, File]},
        vid: {type: String},
    },
}
</script>